<template>
  <div class="tri-manager-tab-table">
    <base-table
      :custom-fetch="fetchMasterRows_"
      :columns="columns_"
      ui-pagination
      ref="baseTable"
    >
      <template #rowCheckbox="{ row }">
        <b-field>
          <b-checkbox
            :value="isChecked(row)"
            @input="(value) => onTableCheck(value, row)"
          />
        </b-field>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

/**
 * Can be standalone component
 */
export default {
  props: {
    /**
     * Method for fetching master data
     */
    fetch: {
      required: true,
    },
    /**
     * Method for fetching active (checked) data
     */
    fetchActive: {
      required: true,
    },
    /**
     * Method for archiving data
     */
    archive: {
      required: true,
    },
    /**
     * Method for restoring data
     */
    restore: {
      required: true,
    },
    columns: {
      type: Array,
    },
  },
  components: {
    BaseTable,
  },
  data: () => ({
    columns_: [
      {
        field: "checkbox",
        label: "",
        meta: {
          rowSlot: "rowCheckbox",
        },
      },
    ],
    rowsChecked: [],
  }),
  mounted() {
    const columns = this.columns || [{ field: "id", label: "ID" }];
    this.columns_ = this.columns_.concat(columns);
    this.fetchRows();
  },
  methods: {
    isCheckedAll() {
      if (this.$refs.baseTable.data.length == 0) return false;
      return this.$refs.baseTable.data.every((v) => this.isChecked(v));
    },
    isChecked(row) {
      return !!this.rowsChecked.find((v) => v.id == row.id);
    },
    fetchRows() {
      this.fetchMasterRows();
      this.fetchActiveRows();
    },
    fetchMasterRows_(params) {
      return this.fetch(params);
    },
    async fetchMasterRows() {
      try {
        await this.$refs.baseTable.fetchData();
      } catch (err) {
        throw err;
      }
    },
    async fetchActiveRows() {
      try {
        const rowsChecked = await this.fetchActive().then((response) =>
          JsonDenormalizer.denormalize(response)
        );
        this.rowsChecked = [];
        this.rowsChecked = rowsChecked;
      } catch (err) {
        throw err;
      }
    },
    onTableCheck(checked, row) {
      this.$nextTick(async () => {
        if (row) {
          try {
            this.$refs.baseTable.loading = true;
            if (checked) {
              await this.restore({ id: row.id });
            } else {
              await this.archive({ id: row.id });
            }
            this.fetchActiveRows();
          } catch (err) {
            throw err;
          } finally {
            this.$refs.baseTable.loading = false;
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tri/TriManagerTabTable.vue